import angular from 'angular';
import buttons from 'ui-bootstrap4/src/buttons';
import popover from 'ui-bootstrap4/src/popover';

import { SchedulerComponent } from './scheduler.component';
import { SchedulerDayPivotCalendarComponent } from './scheduler-day-pivot-calendar.component';
import { SchedulerTimeslotOffsetDirective } from './scheduler-timeslot-offset.directive';
import { SchedulerMonthCalendarComponent } from './scheduler-month-calendar.component';

export const SchedulerModule = angular
    .module("apex.mainApp.scheduler", [
        buttons,
        popover
    ])
    .component("apexScheduler", SchedulerComponent)
    .component("apexSchedulerDayPivotCalendar", SchedulerDayPivotCalendarComponent)
    .component("apexSchedulerMonthCalendar", SchedulerMonthCalendarComponent)
    .directive("apexSchedulerTimeslotOffset", SchedulerTimeslotOffsetDirective)
    .name;
